import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import { LocalStorageKey } from '../model/enumeration/LocalStorageKey';
import { backendApiUrl } from './api-url';

const authRequestInterceptor = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const token = localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);
  if (token) {
    config.headers.Authorization = token;
  }
  config.headers.Accept = 'application/json';
  return config;
};

const createAuthenticatedAxiosInstance = (): AxiosInstance => {
  const newInstance = axios.create({
    baseURL: backendApiUrl,
  });
  newInstance.interceptors.request.use(authRequestInterceptor);
  return newInstance;
};

export const axiosClient = createAuthenticatedAxiosInstance();
